module.exports = __webpack_public_path__ + "img/alert.58149f1a.svg";